import axios from "axios";
import { SETTINGS } from "../../Settings";

export const AppEntryAttachmentsRepository = {
  getAttachment: (attachmentId) => {
    return axios({
      url: `${SETTINGS.EXTERNAL_API_URL}external/appEntries/attachments/${attachmentId}`,
      method: "GET",
      withCredentials: true,
      responseType: "blob",
    });
  },

  getDecision: (appEntryDocId) => {
    return axios({
      url: `${SETTINGS.EXTERNAL_API_URL}external/appEntries/decision/${appEntryDocId}`,
      method: "GET",
      withCredentials: true,
      responseType: "blob",
    });
  },
};
